export default __webpack_public_path__ + "static/media/case-study-11-equipment-supply-chain.43eeb087.mp4";